import React from "react";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.min.css";

const DatePicker = ({ value, onChange, placeholder = "Select date", className = "", ...rest }) => {
  const emitDate = (date) => {
    if (!date) return;
    const y = date.getFullYear();
    const m = String(date.getMonth() + 1).padStart(2, '0');
    const d = String(date.getDate()).padStart(2, '0');
    if (typeof onChange === 'function') {
      onChange({ target: { value: `${y}-${m}-${d}` } });
    }
  };

  const handleChange = ([date]) => emitDate(date);

  // Also capture manually typed dates when the picker closes
  const handleClose = (_selectedDates, _dateStr, instance) => {
    const input = instance.altInput || instance.input;
    if (input && input.value) {
      const parsed = instance.parseDate(input.value, instance.config.altFormat || instance.config.dateFormat);
      if (parsed) emitDate(parsed);
    }
  };

  return (
    <Flatpickr
      value={value || ''}
      onChange={handleChange}
      onClose={handleClose}
      options={{
        dateFormat: 'Y-m-d',
        altInput: true,
        altFormat: 'd/m/Y',
        allowInput: true,
        disableMobile: true,
      }}
      className={`border text-xs md:text-sm rounded-lg p-2.5 py-1.5 px-3 text-content-primary bg-surface-card cursor-pointer ${className}`}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default DatePicker;
